'use client';
import React from 'react';
import Link from 'next/link';
import { Home, Grid3X3, Heart, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


interface BottomNavProps {
  activeRoute: string;
  lang: 'en' | 'ta';
}

const navItems = [
  { href: '/', icon: Home, labelEn: 'Today', labelTa: 'இன்று' },
  { href: '/product-category-browse', icon: Grid3X3, labelEn: 'Browse', labelTa: 'உலாவு' },
  { href: '/watchlist-alert-settings', icon: Heart, labelEn: 'Watchlist', labelTa: 'கண்காணி' },
  { href: '/sign-up-login-screen', icon: User, labelEn: 'Account', labelTa: 'கணக்கு' },
];

export default function BottomNav({ activeRoute, lang }: BottomNavProps) {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-xl border-t border-border bottom-safe">
      <div className="flex items-center justify-around px-2 py-2">
        {navItems.map(item => {
          const Icon = item.icon;
          const isActive = activeRoute === item.href;
          return (
            <Link
              key={`bottom-nav-${item.href}`}
              href={item.href}
              className={`flex flex-col items-center gap-1 px-4 py-2 rounded-2xl transition-all duration-200 ${
                isActive
                  ? 'text-primary bg-secondary' :'text-muted-foreground hover:text-primary'
              }`}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 1.8} />
              <span className="text-xs font-medium">
                {lang === 'en' ? item.labelEn : item.labelTa}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}